import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { IconUIComponent } from '../icon/icon.component';
import { PageHeaderUIComponent } from '../page-header/page-header.component';
import { PageTemplateUIComponent } from '../page-template/page-template.component';

@Component({
  selector: 'fr8bot-ui-dialog-table',
  templateUrl: './dialog-table.component.html',
  // Black from the first frame: the Material panel under it is white until the content arrives.
  host: { class: 'tw:flex tw:min-h-0 tw:min-w-0 tw:flex-auto tw:bg-black' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconUIComponent, NgTemplateOutlet, PageHeaderUIComponent, PageTemplateUIComponent],
})
export class DialogTableComponent {
  readonly showCloseButton = input(true);
  /** Already translated. Without it the content brings its own header and spacing, as a list page does. */
  readonly title = input<string | null>(null);
  readonly closeDialog = output();
}
